<template>
  <div v-if="show" class="mt-2">
    <v-btn
      fab
      small
      depressed
      :color="active ? 'primary' : 'secondary'"
      class="ml-3"
      @click="dialog = true"
    >
      <v-icon v-text="icons.customer" />
    </v-btn>
    <span class="ml-1" v-text="value.fullName" />
    <v-dialog
      v-model="dialog"
      light
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          dense
          color="grey lighten-4"
          class="text-h6"
        >
          <v-icon v-text="icons.customer" color="primary" />
          <v-spacer />
          <v-text-field
            v-model="needle"
            hide-details
            :append-icon="icons.search"
          />
        </v-toolbar>
        <v-divider />
        <v-list v-if="active" class="pa-0">
          <v-list-item @click="unassign()">
            <v-list-item-icon>
              <v-icon v-text="icons.cancel" />
            </v-list-item-icon>
            <v-list-item-title>{{ __('noCustomer') }}</v-list-item-title>
          </v-list-item>
          <v-divider />
        </v-list>
        <v-card-text class="pa-0 full-height">
          <v-list class="pa-0">
            <v-list-item
              v-for="customer in filtered"
              :key="customer.id"
              @click="assign(customer)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ customer.fullName }}</v-list-item-title>
                <v-list-item-subtitle>{{ customer.nif }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      // selected customer
      value: {
        required: true,
        type: Object,
      },
    },

    data: () => ({
      dialog: false,
    }),

    computed: {
      ...mapState('customers', [
        'items',
      ]),
      ...mapGetters('customers', [
        'filtered',
      ]),
      needle: {
        get () {
          return this.$store.state.customers.needle
        },
        set (v) {
          this.$store.commit('customers/needle', v)
        }
      },
      show () {
        return this.items.length > 0
      },
      active () {
        return Object.keys(this.value).length > 0
      },
    },

    methods: {
      assign (customer) {
        this.$emit('input', customer ?? {})
        setTimeout(() => this.needle = '', 1000)
        this.dialog = false
      },
      unassign () {
        this.assign(null)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .full-height {
    height: 100vh;
  }
</style>
